import { apiRequest } from "../index";

export const getDashboardInsights = async () => {
  return apiRequest(`/api/owner/dashboard/insights`, "GET");
};

export const getorderReports = async () => {
  return apiRequest(`/api/owner/dashboard/orders/report`, "GET");
};